import axios from 'axios';
import { go, mapC, chunk, each } from 'fxjs/es';
import { makeThumbnailToProductForCustomer } from '../../../Composite/Thumbnail/F/fs.js';
import { ConfigSentryF } from '../../../Config/Sentry/F/Function/module/ConfigSentryF.js';

let i = 0;
export const productThumbnailMigrationForCustomer = async () => {
  const {
    data: { products },
  } = await axios.get(`/${T.lang}/@api/projection/product-thumbnails`);
  try {
    await go(
      products,
      chunk(10),
      each(
        mapC(async (product) => {
          console.log(++i);
          await go(
            product,
            async (product) => {
              const url = await makeThumbnailToProductForCustomer(product);
              return {
                id: product.id,
                thumbnails: { value: [{ url }] },
              };
            },
            async (product) => await axios.post(`/${T.lang}/@api/product-thumbnail`, product),
          );
        }),
      ),
    );
  } catch (e) {
    ConfigSentryF.error(e, { tags: { module: 'productThumbnailMigrationForCustomer' } });
    console.log(e);
  }
};
